module.exports = __webpack_public_path__ + "static/img/web_banner-02.0f28ab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/web_banner-02.jpg
// module id = XZFu
// module chunks = 1